import React from "react";
import { Route, Switch } from "react-router-dom";

import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { BasicTransactionCreatePage } from "./basic_transaction_create_page";
import { TransactionDetailPage } from "./detail_page";
import { TransactionListPage } from "./list_page";
import { ProductBuyTransactionCreatePage } from "./product_buy_transaction_create_page";
import { ProductSellTransactionCreatePage } from "./product_sell_transaction_create_page";

export const TransactionMainPage: React.FC = () => {
  return (
    <Switch>
      <Route path={ROUTES.transaction} exact>
        <TransactionListPage />
      </Route>

      <Route path={Routing.generateCreateRoute(ROUTES.transaction)} exact>
        <BasicTransactionCreatePage />
      </Route>

      <Route path={`${Routing.generateCreateRoute(ROUTES.transaction)}/sell`}>
        <ProductSellTransactionCreatePage />
      </Route>

      <Route path={`${Routing.generateCreateRoute(ROUTES.transaction)}/buy`}>
        <ProductBuyTransactionCreatePage />
      </Route>

      <Route path={Routing.generateDetailRoute(ROUTES.transaction)}>
        <TransactionDetailPage />
      </Route>
    </Switch>
  );
};
